// Module
var code = `<h3><span>TOPIC:</span> {{title}}</h3>
`;
// Exports
module.exports = code;